export default "__VITE_ASSET__BiUeGM4G__"